import { render, staticRenderFns } from "./DiskDataChart.vue?vue&type=template&id=a73fa54c&scoped=true&"
import script from "./DiskDataChart.vue?vue&type=script&lang=js&"
export * from "./DiskDataChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73fa54c",
  null
  
)

export default component.exports